import {detailServicesPath, ordersServicesPath} from "../../../Constants";
import axios from "axios";

const restUrl = detailServicesPath + '/organizations/postprocessor-settings'

export default class PostprocessorsService {
    static async getAll() {
        return axios.get(restUrl);
    }

    static async getById(id) {
        return axios.get(restUrl + '/' + id);
    }

    static async update(data, id) {
        return await axios.put(restUrl + '/' + id, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async unableDefault(id) {
        // return await axios.put(restUrl + '/' + id, JSON.stringify(data), {
        //     headers: {
        //         'Content-Type': 'application/json'
        //     }
        // });
    }


    static async save(machineId, name) {
        return await axios.post(`${restUrl}?machineId=${machineId}&name=${name}`, JSON.stringify({}), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async delete(id) {
        await axios.delete(restUrl + '/' + id);
    }

    static async setMachineDefault(id) {
        return await axios.patch(restUrl + '/' + id + "/set-machine-default", JSON.stringify({}), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }
}